import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  HostListener,
  Output,
  EventEmitter,
  OnChanges
} from "@angular/core";
import { BaseFormDialogComponent } from "@hub/common/BaseFormDialogComponent";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";

import { ConfirmationService, SelectItem } from "primeng/api";
import { eActionState } from "@hub/generated/enums";
import { Constants } from "@hub/common/Constants";
import { FormService } from "@hub/services/form.service";
import { NotificationService } from "@hub/services/NotificationService";
import { FormEventService } from "@hub/services/form-event.service";
import { PageLoaderService } from "@hub/services/PageLoader";
import { CurrentUserService } from "@hub/services/CurrentUserService";
import { Note } from "@hub/models/note.model";
import { Functions } from "@hub/common/Functions";
import { DateFunctions } from "@hub/common/DateFunctions";

@Component({
  selector: "hub-note-dialog",
  templateUrl: "./note-dialog.component.html"
})
export class NoteDialogComponent extends BaseFormDialogComponent
  implements OnDestroy, OnInit {
  constructor(
    protected fb: FormBuilder,
    protected formService: FormService,
    protected notificationService: NotificationService,
    protected formEventService: FormEventService,
    protected pageLoaderService: PageLoaderService,
    protected currUserService: CurrentUserService,
    protected confirmationService: ConfirmationService
  ) {
    super(
      fb,
      formService,
      formEventService,
      notificationService,
      pageLoaderService,
      confirmationService
    );
  }
  @Input()
  contactId;
  @Input()
  noteEnumType: any;
  @Input()
  isNew: boolean = true;
  selectedNoteData: any;
  @Input()
  selection: any[];
  @Output()
  updateNoteEmitter: EventEmitter<Note> = new EventEmitter();

  types: SelectItem[];
  note: any;
  public formGroup: FormGroup;
  isFormEdit: boolean;
  requiredValidationMessage: string = "Required";

  ngOnInit(): void {
    this.onInit();
  }

  ngOnChanges() {
    try {
      if (this.noteEnumType) {
        this.types = Functions.IterateEnum(this.noteEnumType).map(v => {
          return {
            label: v.label.trim(),
            value: v.value
          };
        });
      }
    } catch (error) { }
  }

  ngOnDestroy() {
    this.ngInitUnsubscribe.next();
    this.ngInitUnsubscribe.complete();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public formInit(): void {
    this.isFormEdit = false;
    this.formService.formEdit(false);

    this.formGroup = this.fb.group({
      Type: [this.noteEnumType != undefined ? this.noteEnumType.NotSet : "", this.noteEnumType != undefined ? Validators.compose([Validators.required, this.checkIfNotSet]) : []],
      Note: ["", Validators.required],
      User: [""]
    });

    this.note = this.selection[0];

    this.formGroup.patchValue({
      Type: this.noteEnumType != undefined ? Functions.getEnumValue(this.noteEnumType, this.note.Type) : "",
      Note: this.note.Note || "",
      User: this.note.User
    });

  }

  public saveActionHandler(e: any): void {
    if (e) {
      this.pageLoaderService.showPageLoader();
      this.display = false;
      this.updateNoteEmitter.emit(this.getNoteFormValues());
    }
  }
  public onAcceptConfirmationHandler(): void { }
  public onCloseInvalidFormHandler(): void { }
  public formValueChangeHandler(data: any): void {
    if (this.isFormEdit === false) {
      this.formService.formEdit(true);
      this.isFormEdit = true;
    }
  }

  public save() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("overflow-hidden-scroll");
    body.classList.add("overflow-show-scroll");
    this.formService.saveClick();
  }

  public cancel() {
    this.hide();
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("overflow-hidden-scroll");
    body.classList.add("overflow-show-scroll");
    this.pageLoaderService.hidePageLoader();
  }

  afterShow() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("overflow-show-scroll");
    body.classList.add("overflow-hidden-scroll");
  }

  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: any) {
    this.hide();
    if (!this.CanDeactivate()) {
      $event.returnValue = "Do you want to refresh";
    }
  }

  private CanDeactivate(): boolean {
    return !this.isFormEdit;
  }

  private getNoteFormValues() {
    const val = this.formGroup.value;
    const editNote: Note = {
      Id: this.isNew
        ? Constants.GUID_EMPTY
        : this.note.Id,
      ContactId: this.contactId,
      Type: this.noteEnumType ? Functions.getEnumName(this.noteEnumType, val.Type) : "",
      Note: val.Note,
      Date: DateFunctions.adjustDate(new Date(), true),
      ActionState: this.isNew ? eActionState.Inserted : eActionState.Changed,
      User: val.User
    };

    return editNote;
  }

  private checkIfNotSet(control: FormControl) {
    let selectedEnum = control.value;

    if (selectedEnum === 0) {
      return {
        required: true
      };
    }
    return null;
  }
}
